import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomDropdown from '@components/CustomDropdown';

import { getFilterTextFieldValue } from '@features/filter/static/filterUtil';

import { updateTextItemInGlobalFilter } from '@store/actions/FilterAction';

import { fetchEnumValues } from '@services/commonService';

const BrandType = () => {
	const [brandTypes, setBrandTypes] = useState([]);
	const filterData = useSelector((store) => store.filterFieldStore);
	const inputValue = getFilterTextFieldValue(filterData, 'brandType', 'brandType');
	const dispatch = useDispatch();

	useEffect(() => {
		fetchEnumValues('info.nitex.app.brand.BrandType', setBrandTypes);
	}, []);

	const onBrandClick = (obj) => {
		let data = {
			name: 'brandType',
			type: 'text',
			key: obj.id,
			value: obj.value,
			identifier: 'brandType'
		};
		dispatch(updateTextItemInGlobalFilter(data));
	};

	return (
		<CustomDropdown
			type="addItem"
			title={'Brand Type'}
			isShowLabel={false}
			onItemClick={onBrandClick}
			items={brandTypes?.map((item) => ({ id: item.id, value: item.label }))}
			selectedItem={inputValue?.value || 'Brand Type'}
		/>
	);
};

export default BrandType;
